import ESSearchService from 'lib/workperks/services/ESSearchService';
import ADSearchService from 'lib/workperks/services/ADSearchService';
import SearchService, { SearchServiceOptions, SerializedSearchService } from 'lib/workperks/services/SearchService';

const createSearchServiceWithOptions = (options: SearchServiceOptions): SearchService => {

  return options.location.country === 'US' ? new ADSearchService(options) : new ESSearchService(options);
};

export const createSearchServiceWithSerialization = (
  serializedSearchService: SerializedSearchService,
): SearchService => {
  return serializedSearchService.location.country === 'US'
    ? ADSearchService.unserialize(serializedSearchService)
    : ESSearchService.unserialize(serializedSearchService);
};

export default createSearchServiceWithOptions;
